export function createQuery(host, type, durationStart = "-60m", durationEnd = "0m", durationInterval = "5m"){
    if (type === 'snmp'){
        return `
            from(bucket: "telegraf")
                |> range(start: ${durationStart}, stop: ${durationEnd})
                |> filter(fn: (r) => r["_measurement"] == "snmp")
                |> filter(fn: (r) => r["agent_host"] == "${host}")
                |> filter(fn: (r) => r["_field"] == "mem_avail_real" or r["_field"] == "mem_used_real" or r["_field"] == "mem_cached" or r["_field"] == "mem_buffer" )
                |> aggregateWindow(every: ${durationInterval}, fn: max, createEmpty: true)
                |> yield(name: "max")
            `;
    }
    else {
        return `
from(bucket: "telegraf")
  |> range(start: ${durationStart}, stop: ${durationEnd})
  |> filter(fn: (r) => 
    r["_measurement"] == "ezelink_memory_value" and
    r["host"] == "${host}" and
    r["type"] == "percent" and
    (
      r["type_instance"] == "free" or
      r["type_instance"] == "cached" or
      r["type_instance"] == "buffered" or
      r["type_instance"] == "used"
    )
  )
  |> aggregateWindow(every: ${durationInterval}, fn: max, createEmpty: true)
  |> map(fn: (r) => ({ r with _value: r._value }))  // Convert bytes to KB
  |> yield(name: "max")

            `;
    }
}